import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})

export class TranslateServiceApi {


  // private ip = 'http://35.232.140.117:3800';

  constructor(
    private httpClient: HttpClient
  ) { }



  public getLanguajesList(data) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.idiomasGuardados+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Idiomas/'+this.getCompanyID(),data,
  //    { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getLanguajesListNon3(data) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.forAll.getLanguajesListNon3+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Idiomas/all/'+this.getCompanyID(),data,
    //                             { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getLanguajesListSelected(data) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.forAll.getLanguajesListSelected+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Idiomas/agregados/'+this.getCompanyID(),data,
    //                             { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getTraducciones(data) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.forAll.getTraducciones+this.getCompanyID(), data);
    // return this.httpClient.post(this.ip+'/api_empresa/Forall/Traducciones/'+
    // this.getCompanyID(), data,
    //   { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  public insertTranslate(data) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.forAll.insertTranslate+this.getCompanyID(), data);
    // return this.httpClient.post(this.ip+'/api_empresa/Forall/Guardar/Traduccion/'+
    // this.getCompanyID(), data,
    //   { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public registerForall(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.forAll.postGuardar+
    this.getCompanyID(), data);
    // return this.httpClient.post(this.ip+'/api_empresa/Forall/Guardar/'+
    // this.getCompanyID(), data,
    //   { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  private getToken():string{
    const token = localStorage.getItem('token');

    return token;
  }



  private getCompanyID():string{
    const token = localStorage.getItem('companyID');

    return token;
  }




}
